import { AppContext } from 'next/app'

import { serveRedirect } from '../response'

export const newNetworkRedirect = (ctx: AppContext) => {
  const host = ctx.ctx.req?.headers?.host
  const pathname = ctx.ctx.req?.url || ''
  const newRouting = pathname.startsWith('/n/')

  if (host && !newRouting) {
    const hostParts = host.split('.')

    if (hostParts.length > 2 && hostParts[0] !== 'www') {
      const [network, origin, domain] = hostParts
      const redirectUrl = `https://${origin}.${domain}/n/${network}${pathname}`

      serveRedirect(ctx.ctx.res, '', redirectUrl, {
        statusCode: 301,
        replace: true
      })
      return true
    }
  }
}
